import * as React from 'react';
const UpRightIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.629 5.642a.5.5 0 0 0-.462-.309H5.833a.5.5 0 0 0 0 1h7.127l-7.48 7.48a.5.5 0 1 0 .707.707l7.48-7.48v7.127a.5.5 0 0 0 1 0V5.83a.5.5 0 0 0-.038-.188"
      fill="currentColor"
    />
  </svg>
);
export default UpRightIcon;
